import { TutorProfileService, TutorProfile } from './interfaces';
import { doc, getDoc, setDoc, Firestore, deleteDoc } from 'firebase/firestore';
import { firestore } from './firebase';
import { logger } from './LoggerService';

export class FirebaseTutorProfileService implements TutorProfileService {
  private firestore: Firestore;

  constructor() {
    this.firestore = firestore;
  }

  private createProfileObject(id: string): TutorProfile {
    return {
      uid: id,
      firstName: '',
      lastName: '',
      title: '',
      bio: '',
      rating: 0,
      numReviews: 0,
      price: 0,
      location: '',
      subjects: [],
    };
  };

  getTutorProfile = async (id: string): Promise<TutorProfile> => {
    const docRef = doc(this.firestore, 'tutors', id); //this.firestore.collection('tutors').doc(id);
    const docSnap = await getDoc(docRef);
    //const doc = await docRef.get();

    if (!docSnap.exists) {
      throw new Error('Tutor profile not found');
    }
    const data = docSnap.data();
    if (!data) {
      throw new Error('Empty tutor profile data');
    }

    return { uid: docSnap.id, ...data };
  };

  createTutorProfile = async (
    id: string,
    profile?: TutorProfile
  ): Promise<TutorProfile> => {
    try {
      const docRef = doc(this.firestore, 'tutors', id);
      const tutorProfileData = profile ? profile : this.createProfileObject(id);
      await setDoc(docRef, tutorProfileData);
      // Return the tutor profile data
      return (await this.getTutorProfile(id)) as TutorProfile;
    } catch (error: any) {
      logger.error('Failed to create tutor profile', error);
      throw new Error('Failed to create tutor profile');
    }
  };

  updateTutorProfile = async (
    id: string,
    profile: TutorProfile
  ): Promise<TutorProfile> => {
    return this.createTutorProfile(id, profile);
  };

  deleteUserProfile = async (id: string): Promise<void> => {
    try {
      const docRef = doc(this.firestore, 'tutors', id);
      await deleteDoc(docRef);
    } catch (error: any) {
      logger.error('Failed to delete tutor profile', error);
      throw new Error('Failed to delete tutor profile');
    }
  };
}

const ftps = new FirebaseTutorProfileService();
export default ftps;
